const WalletStatus = {
  idle: "idle",
  connecting: "connecting",
  connected: "connected",
};

export default WalletStatus;
